import * as React from 'react'
import cn from 'classnames'
import { FormattedHTMLMessage, MessageDescriptor } from 'react-intl'

import { CheckIcon } from '../icon'
import styles from './featureGrid.module.scss'

interface IFeatureGridProps {
  features: { title: MessageDescriptor; text: MessageDescriptor }[]
  cols?: 1 | 2 | 3
}

const getColsClassName = (cols: number) => {
  return [styles.oneCol, styles.twoCols, styles.threeCols][cols - 1]
}

const FeatureGrid = ({ features, cols = 2 }: IFeatureGridProps) => (
  <div className={styles.root}>
    <div className={styles.outer}>
      <div className={styles.inner}>
        <div className={cn(styles.features, getColsClassName(cols))}>
          {features.map((feature) => (
            <div className={styles.feature} key={feature.title.defaultMessage}>
              <CheckIcon theme="success" />
              <FormattedHTMLMessage tagName="h4" {...feature.title} />
              <FormattedHTMLMessage tagName="p" {...feature.text} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
)

export default FeatureGrid
